import { getTemplateSaveMetadataForUpsert, type TemplateSaveMetadataForUpsert } from 'adflow';

export function withTemplateSaveMetadata<T extends Record<string, unknown>>(
  data: T,
): T & Partial<TemplateSaveMetadataForUpsert> {
  const metadata = getTemplateSaveMetadataForUpsert();
  if (!metadata) {
    return data;
  }
  return {
    ...data,
    saveInvocationId: metadata.saveInvocationId,
    saveSource: metadata.saveSource,
    expectedWorkingRevision: metadata.expectedWorkingRevision,
    ...(metadata.expectedPersistedRevision != null
      ? { expectedPersistedRevision: metadata.expectedPersistedRevision }
      : {}),
  };
}
